import { render, staticRenderFns } from "./confirm-sign-up.vue?vue&type=template&id=26cc6b53"
import script from "./confirm-sign-up.vue?vue&type=script&lang=js"
export * from "./confirm-sign-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports